var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ParticlesGenerator"},_vm._l((_vm.particles),function(particle){return _c('div',{key:particle.id,staticClass:"ParticlesGenerator-particle",style:(`left: ${particle.x}; width: ${particle.size}; height: ${particle.size}; animation-duration: ${particle.speed};`),attrs:{"data-animation":particle.animation}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }